import { render, staticRenderFns } from "./CommunityGroupList.vue?vue&type=template&id=46a6ce73&"
import script from "./CommunityGroupList.vue?vue&type=script&lang=js&"
export * from "./CommunityGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports